import axios from 'axios';
import { TIME_OUT, BASE_URL } from './config';
import { getFromSessionStorage } from 'Chores/utils';

const instance = axios.create({
  baseURL: BASE_URL,
  timeout: TIME_OUT,
  withCredentials: true,
  headers: {
    __tenant: 'DashboardPlus',
    __project: null
  }
});

instance.interceptors.request.use(
  (config) => {
    config.headers.Authorization = `Bearer ${getFromSessionStorage('token')}`;
    return config;
  },
  (err) => {
    err.message = 'Server exception';
    return Promise.reject(err);
  }
);

instance.interceptors.response.use(
  (response) => {
    if (response.status >= 200 && response.status < 300) {
      return response.data;
    }
  },
  (err) => {
    if (err.code === 'ERR_CANCELED') {
      return Promise.reject(err);
    }
    const shouldSkipGlobalErrorNotify = err?.config?.skipGlobalErrorNotify === true;
    const responseError = err?.response?.data?.error || err?.response?.data || {};
    const isBillingInvoiceUploadValidationError =
      [409, 422].includes(err?.response?.status) &&
      String(responseError?.code || '').startsWith('BillingInvoice');
    const hasValidationErrors = Array.isArray(responseError?.validationErrors) && responseError.validationErrors.length > 0;

    if (err.response?.status === 401) {
      window.location.href = '/';
    } else if (err.response?.status === 403) {
      const detail = responseError?.message;
      err.message = (typeof detail === 'string' && detail.trim()) ?
        detail :
        'The permission is denied.';
    } else if (isBillingInvoiceUploadValidationError) {
      err.message = responseError?.message || err.message;
    }

    if (!shouldSkipGlobalErrorNotify && !hasValidationErrors) {
      VegaNotify.open({
        type: 'error',
        message: err.message
      });
    }

    return Promise.reject(err.response || err);
  }
);

export default instance;
